function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
// src/hooks/useResizeObserver.ts
var useResizeObserver = function(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        trackWidth: true,
        trackHeight: true
    };
    var _useState = _sliced_to_array(useState({
        width: 0,
        height: 0
    }), 2), size = _useState[0], setSize = _useState[1];
    useEffect(function() {
        var resizeObserver = new ResizeObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.target === element) {
                    var _entry_contentRect = entry.contentRect, width = _entry_contentRect.width, height = _entry_contentRect.height;
                    var newSize = _object_spread({}, size);
                    if (options.trackWidth && width !== size.width) {
                        newSize.width = width;
                    }
                    if (options.trackHeight && height !== size.height) {
                        newSize.height = height;
                    }
                    if (newSize.width !== size.width || newSize.height !== size.height) {
                        setSize(newSize);
                    }
                }
            });
        });
        if (element) {
            resizeObserver.observe(element);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        element,
        options.trackWidth,
        options.trackHeight,
        size
    ]);
    return size;
};
var useParentElementClick = function(onClickOutside) {
    var ref = useRef(null);
    var handleClick = useCallback(function(e) {
        var _ref_current, _ref_current1;
        var parentNode = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.parentNode;
        if (parentNode && !((_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.contains(e.target))) {
            onClickOutside(e);
        }
    }, [
        ref,
        onClickOutside
    ]);
    useEffect(function() {
        var _ref_current;
        var parentNode = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.parentNode;
        if (!parentNode) {
            return;
        }
        parentNode.addEventListener("click", handleClick);
        return function() {
            parentNode.removeEventListener("click", handleClick);
        };
    }, [
        ref,
        handleClick
    ]);
    return ref;
};
// src/hooks/useSelect/isGenericIsArray.ts
var isGenericIsArray = function(array) {
    return array.every(function(item) {
        return typeof item === "object" && item !== null;
    });
};
// src/hooks/useSelect/getInitialSelected.ts
var getInitialSelected = function(data, defaultSelected, key) {
    var initialSelectedItems = [];
    if (defaultSelected) {
        if (isGenericIsArray(defaultSelected)) {
            initialSelectedItems = defaultSelected;
        } else {
            initialSelectedItems = data.filter(function(item) {
                return defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.includes(item[key]);
            });
        }
    }
    return initialSelectedItems;
};
// src/hooks/useSelect/useSelect.ts
function useSelect(mode, data, options) {
    if (!data) {
        throw new Error("data는 필수 값입니다.");
    }
    if (data.length > 0 && (options === null || options === void 0 ? void 0 : options.key) && !data[0][options.key]) {
        throw new Error("입력받은 key가 data에 존재하지 않습니다. 올바른 key를 입력해주세요.");
    }
    if ((options === null || options === void 0 ? void 0 : options.max) && options.max < 1) {
        throw new Error("max는 0보다 커야 합니다.");
    }
    var initialSelected = getInitialSelected(data, (options === null || options === void 0 ? void 0 : options.defaultSelected) || [], options === null || options === void 0 ? void 0 : options.key);
    var _useState = _sliced_to_array(useState(initialSelected), 2), selectedItem = _useState[0], setSelectedItem = _useState[1];
    var key = (options === null || options === void 0 ? void 0 : options.key) || "id";
    var result = useMemo(function() {
        return mode === "MULTI" ? selectedItem : selectedItem[0] || null;
    }, [
        selectedItem,
        mode
    ]);
    var findItemById = useCallback(function(id) {
        return data.find(function(item) {
            return item[key] === id;
        });
    }, [
        data,
        key
    ]);
    var handleSelect = useCallback(function(id) {
        var newItem = findItemById(id);
        if (newItem) {
            setSelectedItem(function(currentSelected) {
                if (mode === "MULTI") {
                    return _to_consumable_array(currentSelected).concat([
                        newItem
                    ]);
                } else {
                    return [
                        newItem
                    ];
                }
            });
        }
    }, [
        findItemById,
        mode
    ]);
    var handleRemove = useCallback(function(id) {
        setSelectedItem(function(currentSelected) {
            return currentSelected.filter(function(item) {
                return item[key] !== id;
            });
        });
    }, [
        setSelectedItem,
        key
    ]);
    var handleToggleSelect = useCallback(function(id) {
        var isSelected = selectedItem.find(function(item) {
            return item[key] === id;
        });
        if (isSelected) {
            handleRemove(id);
        }
        if (!isSelected) {
            if ((options === null || options === void 0 ? void 0 : options.max) && selectedItem.length >= options.max) {
                return;
            }
            handleSelect(id);
        }
    }, [
        handleRemove,
        handleSelect,
        options === null || options === void 0 ? void 0 : options.max,
        selectedItem,
        key
    ]);
    var handleReset = useCallback(function() {
        setSelectedItem([]);
    }, []);
    return {
        selectedItem: result,
        handleReset: handleReset,
        handleToggleSelect: handleToggleSelect,
        handleSelect: handleSelect,
        handleRemove: handleRemove
    };
}
function assignRef(ref, value) {
    if (ref == null) {
        return;
    }
    if (typeof ref === "function") {
        ref(value);
        return;
    }
    try {
        ref.current = value;
    } catch (error) {
        throw new Error("Cannot assign value '".concat(String(value), "' to ref '").concat(String(ref), "'"));
    }
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(node) {
        refs.forEach(function(ref) {
            assignRef(ref, node);
        });
    };
}
function useMergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return useMemo(function() {
        return mergeRefs.apply(void 0, _to_consumable_array(refs));
    }, refs);
}
var useOutsideClick = function(param) {
    var selector = param.selector, useOutsideScroll = param.useOutsideScroll, onClose = param.onClose;
    var _useState = _sliced_to_array(useState(false), 2), isOpened = _useState[0], setIsOpened = _useState[1];
    useEffect(function() {
        if (!selector && !useOutsideScroll) {
            return;
        }
        var handleOutClick = function(e) {
            if (!selector) {
                return;
            }
            var target = e.target;
            var checkClickedTarget = target.closest(selector) || target.closest("#popover");
            if (checkClickedTarget === null) {
                onClose ? onClose() : setIsOpened(false);
            }
        };
        var handleScroll = function() {
            onClose && onClose();
        };
        if (selector) {
            setTimeout(function() {
                document.addEventListener("click", handleOutClick);
            }, 0);
        }
        if (useOutsideScroll) {
            setTimeout(function() {
                document.addEventListener("scroll", handleScroll);
                document.addEventListener("wheel", handleOutClick);
            }, 0);
        }
        return function() {
            if (!selector && !useOutsideScroll) {
                return;
            }
            if (selector) {
                document.removeEventListener("click", handleOutClick);
            }
            if (useOutsideScroll) {
                document.removeEventListener("scroll", handleScroll);
                document.removeEventListener("wheel", handleOutClick);
            }
        };
    }, [
        selector,
        useOutsideScroll,
        onClose
    ]);
    useEffect(function() {
        return function() {
            return setIsOpened(false);
        };
    }, []);
    return [
        isOpened,
        setIsOpened
    ];
};
// src/utils/debounce.ts
var debounce = function(func, ms) {
    var timeoutId;
    return function debounce() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _this = this;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            return func.apply(_this, args);
        }, ms);
    };
};
// src/utils/extractColors.ts
var extractColors = function(tokens, tokenName) {
    var result = Object.keys(tokens).reduce(function(acc, key) {
        if (key.includes(tokenName)) {
            acc[key] = tokens[key];
        }
        return acc;
    }, {});
    return result;
};
// src/utils/noop.ts
var noop = function noop() {};
// src/utils/throttle.ts
var throttle = function(fn) {
    var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var inThrottle, lastFn, lastTime;
    return function throttle() {
        var context = this, args = arguments;
        if (!inThrottle) {
            fn.apply(context, args);
            lastTime = Date.now();
            inThrottle = true;
        } else {
            clearTimeout(lastFn);
            lastFn = setTimeout(function() {
                if (Date.now() - lastTime >= wait) {
                    fn.apply(context, args);
                    lastTime = Date.now();
                }
            }, Math.max(wait - (Date.now() - lastTime), 0));
        }
    };
};
// src/utils/isNullOrUndefined.ts
var isNullOrUndefined = function(value) {
    if (value === void 0) {
        return true;
    }
    if (value === null) {
        return true;
    }
    return false;
};
var OutSideClick = function(param) {
    var children = param.children, outsideClick = param.outsideClick, _param_trigger = param.trigger, trigger = _param_trigger === void 0 ? true : _param_trigger;
    var ref = useRef(null);
    var handleClick = useCallback(function(e) {
        if (ref.current && !ref.current.contains(e.target)) {
            outsideClick(e.target);
        }
    }, [
        outsideClick
    ]);
    useEffect(function() {
        if (trigger) {
            setTimeout(function() {
                return document.addEventListener("click", handleClick);
            }, 0);
        }
        return function() {
            document.removeEventListener("click", handleClick);
        };
    }, [
        handleClick,
        trigger
    ]);
    return /* @__PURE__ */ jsx("div", {
        ref: ref,
        children: children
    });
};
// src/utils/SwitchCase.tsx
var SwitchCase = function(param) {
    var value = param.value, caseBy = param.caseBy;
    if (value in caseBy) {
        return caseBy[value];
    }
    return null;
};
export { OutSideClick, SwitchCase, assignRef, debounce, extractColors, isNullOrUndefined, mergeRefs, noop, throttle, useMergeRefs, useOutsideClick, useParentElementClick, useResizeObserver, useSelect }; //# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map